import { CancelablePromise } from "cancelable-promise";
import { JamTileStatus, JamTileImageProps, TilesProps } from "../types.js";
import { TILE_INCREMENT, TILE_SIZE } from "../const.js";

export function getTilesProps({
  margin,
  width,
  height,
  tileSize = TILE_SIZE,
  tileIncrement = TILE_INCREMENT,
}: TilesProps) {
  width += margin.left + margin.right;
  height += margin.top + margin.bottom;

  const w = Math.ceil(width / tileSize) + tileIncrement;
  const h = Math.ceil(height / tileSize) + tileIncrement;

  const wDiff = (tileSize * w - width) / 2;
  const hDiff = (tileSize * h - height) / 2;

  width = tileSize * w;
  height = tileSize * h;
  margin = {
    top: margin.top + hDiff,
    right: margin.right + wDiff,
    bottom: margin.bottom + hDiff,
    left: margin.left + wDiff,
  };

  return {
    tileSize,
    w,
    h,
    width,
    height,
    margin,
  };
}

export function getTilesFunctions(props: ReturnType<typeof getTilesProps>) {
  const { w: wCount, h: hCount, tileSize, margin } = props;

  const halfWCount = wCount / 2;
  const halfHCount = hCount / 2;

  const { top, right, bottom, left } = margin;
  function getTiles() {
    const tiles: JamTileStatus[] = [];
    for (let h = 0; h < hCount; h++) {
      for (let w = 0; w < wCount; w++) {
        const margin = {
          top: top - tileSize * h,
          right: right - tileSize * (wCount - 1 - w),
          bottom: bottom - tileSize * (hCount - 1 - h),
          left: left - tileSize * w,
        };
        tiles.push({
          w,
          h,
          margin,
        });
      }
    }

    return tiles;
  }
  function getImages(tiles: JamTileImageProps[]) {
    return tiles
      .sort((a, b) => {
        const aW = Math.abs(a.w - halfWCount);
        const aH = Math.abs(a.h - halfHCount);
        const bW = Math.abs(b.w - halfWCount);
        const bH = Math.abs(b.h - halfHCount);
        const aDiff = aW + aH;
        const bDiff = bW + bH;
        return aDiff < bDiff ? -1 : 1;
      })
      .map((tile) => {
        let promise: CancelablePromise<JamTileImageProps>;
        return () => {
          if (promise) return promise;

          promise = new CancelablePromise<JamTileImageProps>(
            (resolve, _, onCancel) => {
              const { getImage } = tile;
              const req = getImage();
              req
                .then(createImageBitmap)
                .then((img) => {
                  tile.img = img;
                  return resolve(tile);
                })
                .catch(console.error);

              onCancel(() => {
                if (!req.isCanceled()) {
                  req.cancel();
                }
              });
            }
          );
          return promise;
        };
      });
  }

  return {
    getTiles,
    getImages,
  };
}
